
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pregnancy-after-nexplanon",
      function () {
        return require("private-next-pages/pregnancy-after-nexplanon.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pregnancy-after-nexplanon"])
      });
    }
  